import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {Point} from '@app/modules/svg/model/Point';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {MoveDrawer} from '@app/modules/svg/service/tool/draw/mode/MoveDrawer';
import {MoveDrawable} from '@app/modules/svg/service/tool/draw/type/MoveDrawable';
import {CosView} from '@app/modules/svg/element/complex/cartesian/graphic/CosView';

export class DrawCos extends MoveDrawer {
  protected createDrawableElement(position: Point): MoveDrawable {
    return new CosView(
      this.drawTool.container,
      {overEvent: true, globalStyle: true, periods: 2},
      position,
      position
    );
  }

  public override start(call: boolean): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.COS_TOOL_ON);
    }
  }
  public override stop(call: boolean): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.COS_TOOL_OFF);
    }
  }

  public _new(): DrawCos {
    return new DrawCos(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.COS;
  }
}
